<template>
  <div class="WechatUsers app-container">
    <el-card class="box-card">
      <el-form
        :inline="true"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-button
            type="primary"
            @click="dialogTableVisible = true"
          >上传报表
            <input ref="file" style="display: none;" type="file" accept=".xlsx" @change="uploadPictures">
          </el-button>

        </el-form-item>

        <el-form-item label="关键字">
          <el-input
            v-model="reportQuery.factor"
            placeholder="请输入关键字"
          />
        </el-form-item>
        <!-- <el-form-item label="任务类型">
          <el-select
            v-model="reportQuery.type"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in reportSelectList.type_list"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="任务状态">
          <el-select
            v-model="reportQuery.status"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in reportSelectList.status_list"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="search"
          >查询</el-button>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="reset"
          >重置</el-button>
        </el-form-item>
      </el-form>
      <main>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="任务ID"
            min-width="90"
          />
          <el-table-column
            prop="type_str"
            label="任务类型"
            min-width="90"
          />
          <el-table-column
            prop="factor"
            label="查询条件"
            min-width="200"
          />
          <el-table-column
            prop="created_at"
            label="创建时间"
            min-width="200"
          />
          <el-table-column
            prop="status_str"
            label="任务状态"
            min-width="80"
          />
          <el-table-column
            prop="date"
            label="操作"
            min-width="80"
            align="center"
          >
            <template scope="scope">
              <a
                :href="scope.row.url"
                :style="scope.row.url === null ? 'pointer-events: none; color: #ccc;' : 'color: 	#409EFF'"
              >下载</a>
            </template>
          </el-table-column>
        </el-table>
      </main>
      <pagination-right
        :total="total"
        :page-sizes="[10]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>

    <el-dialog title="选择下载类型" :visible.sync="dialogTableVisible" style="text-align: center;">
      <el-button type="primary" @click="mySelec('user')">用户</el-button>
      <el-button type="primary" @click="mySelec('order')">订单</el-button>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, reportSelect } from '@/api/report/exportLog.js'
import { qiniuToken } from '@/api/qiniuToken.js'
import { importOpenId } from '@/api/report/openID.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      reportSelectList: [], // 平台筛选列表
      reportQuery: {
        factor: null,
        type: 5,
        status: null,
        page: 1,
        page_size: 10
      },
      tableData: null, // 表格数据
      loading: false, // 加载效果
      total: null,
      token: null,
      type: null,
      dialogTableVisible: false
    }
  },
  async created() {
    window.aaa = this
    this.getListData()
    this.getReportSelect()
    const data = await qiniuToken()
    this.token = data.data.uptoken
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.loading = true
      getList(this.reportQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 获取筛选列表
    getReportSelect() {
      this.loading = true
      reportSelect().then(res => {
        this.reportSelectList = res.data
        this.loading = false
      })
    },
    // 重置请求数据
    resetData() {
      this.reportQuery = {
        task_id: null,
        type: null,
        status: null,
        page: 1,
        page_size: 10
      }
    },
    // 分页
    fetchPageSize(e) {
      this.reportQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.reportQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.reportQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.resetData()
      this.getListData()
    },
    mySelec(value) {
      this.type = value
      this.$refs.file.click()
    },
    async uploadPictures(e) {
      const file = new FormData()
      file.append('file', e.target.files[0])
      file.append('type', this.type)
      this.dialogTableVisible = false
      this.$refs.file.type = null
      await importOpenId(file)
      this.$refs.file.type = 'file'
      this.$message({
        message: '上传成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="less">
.WechatUsers {
  min-width: 1200px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
